module.exports = __webpack_public_path__ + "img/failed.163114b4.gif";